import { getIdApiUserData, } from '@root/src/web/lib/getIdapiUserData';
export const getBrazeUuid = async (ajaxUrl) => {
    return getIdApiUserData(ajaxUrl)
        .then((data) => data.user?.privateFields?.brazeUuid)
        .catch((error) => {
        window.guardian.modules.sentry.reportError(error, 'getBrazeUuid');
    });
};
